import { useDebugLogs } from '~/composables/useDebugLogs'

export default defineNuxtPlugin((nuxtApp) => {
    const { addLog } = useDebugLogs()

    nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
        console.error('[Global Error Handler]', error, info)
        addLog(
            `Vue Error: ${error instanceof Error ? error.message : String(error)}`,
            'error',
            { info, stack: error instanceof Error ? error.stack : null }
        )
    }

    // Optional: Catch promise rejections?
    // window.addEventListener('unhandledrejection', ...) - Requires client-side check
})
